<template>
     <el-tabs type="card" v-model="gameId"  @tab-click="handleClick" width="300px" >
        <el-tab-pane name="5" label="宫廷秘传IOS">
            <el-tabs type="border-card">
                <el-tab-pane label="游戏数据">
                    <el-tabs type="border-card">
                        <el-tab-pane >
                        <span slot="label" ><i class="el-icon-view"></i> 图表</span>
                            <v-chart :force-fit="true"  :height="400" :data="view.gtmzios">
                                <v-tooltip />
                                <v-axis />
                                <v-legend style="margin-right:40px"/>
                                <v-line position="month*temperature" color="city" />
                                <v-point position="month*temperature" color="city" :size="4" :v-style="style" />
                            </v-chart>
                        </el-tab-pane>
                        <el-tab-pane >
                        <span slot="label"><i class="el-icon-date"></i> 表格</span>
                            <!--表格start-->
                            <el-table
                                :data="list.gtmzios"
                                border
                                style="width: 100% height:100%">
                                <el-table-column
                                    fixed
                                    prop="countDate"
                                    label="日期"
                                    width="100"
                                    align="center"
                                >
                                </el-table-column>
                                <el-table-column
                                    prop="addRegNum"
                                    label="新增"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="activeNum"
                                    label="活跃"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="payNum"
                                    label="付费"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                 <el-table-column
                                    prop="payAmountTotal"
                                    label="付费金额"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="addPayNum"
                                    label="新增付费数"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="addPayAmountTotal"
                                    label="新增充值"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="addPayRate"
                                    label="新增付费率"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="activeArpu"
                                    label="arpu"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="activeArppu"
                                    label="arppu"
                                    width="100"
                                    align="center">
                                </el-table-column>
                            </el-table>
                            <!--表格end-->
                        </el-tab-pane>
                    </el-tabs>
                </el-tab-pane>
            </el-tabs>
        </el-tab-pane>

        <el-tab-pane name="55" label="宫廷秘传Android">
            <el-tabs type="border-card">
                <el-tab-pane label="游戏数据">
                    <el-tabs type="border-card">
                        <el-tab-pane >
                        <span slot="label" ><i class="el-icon-view"></i> 图表</span>
                            <v-chart :force-fit="true"  :height="400" :data="view.gtmzand">
                                <v-tooltip />
                                <v-axis />
                                <v-legend style="margin-right:40px"/>
                                <v-line position="month*temperature" color="city" />
                                <v-point position="month*temperature" color="city" :size="4" :v-style="style" />
                            </v-chart>
                        </el-tab-pane>
                        <el-tab-pane >
                        <span slot="label"><i class="el-icon-date"></i> 表格</span>
                            <!--表格start-->
                            <el-table
                                :data="list.gtmzand"
                                border
                                style="width: 100% height:100%">
                                <el-table-column
                                    fixed
                                    prop="countDate"
                                    label="日期"
                                    width="100"
                                    align="center"
                                >
                                </el-table-column>
                                <el-table-column
                                    prop="addRegNum"
                                    label="新增"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="activeNum"
                                    label="活跃"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="payNum"
                                    label="付费"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                 <el-table-column
                                    prop="payAmountTotal"
                                    label="充值金额"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="addPayNum"
                                    label="新增付费数"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="addPayAmountTotal"
                                    label="新增充值"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="addPayRate"
                                    label="新增付费率"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="activeArpu"
                                    label="arpu"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="activeArppu"
                                    label="arppu"
                                    width="100"
                                    align="center">
                                </el-table-column>
                            </el-table>
                            <!--表格end-->
                        </el-tab-pane>
                    </el-tabs>
                </el-tab-pane>
            </el-tabs>
        </el-tab-pane>
















        <el-tab-pane name="4" label="塞尔之光IOS">
            <el-tabs type="border-card">
                <el-tab-pane label="游戏数据">
                    <el-tabs type="border-card">
                        <el-tab-pane >
                        <span slot="label" ><i class="el-icon-view"></i> 图表</span>
                            <v-chart :force-fit="true"  :height="400" :data="view.srzgios">
                                <v-tooltip />
                                <v-axis />
                                <v-legend style="margin-right:40px"/>
                                <v-line position="month*temperature" color="city" />
                                <v-point position="month*temperature" color="city" :size="4" :v-style="style" />
                            </v-chart>
                        </el-tab-pane>
                        <el-tab-pane >
                        <span slot="label"><i class="el-icon-date"></i> 表格</span>
                            <!--表格start-->
                            <el-table
                                :data="list.srzgios"
                                border
                                style="width: 100% height:100%">
                                <el-table-column
                                    fixed
                                    prop="countDate"
                                    label="日期"
                                    width="100"
                                    align="center"
                                >
                                </el-table-column>
                                <el-table-column
                                    prop="addRegNum"
                                    label="新增"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="activeNum"
                                    label="活跃"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="payNum"
                                    label="付费"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                 <el-table-column
                                    prop="payAmountTotal"
                                    label="充值金额"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="addPayNum"
                                    label="新增付费数"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="addPayAmountTotal"
                                    label="新增充值"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="addPayRate"
                                    label="新增付费率"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="activeArpu"
                                    label="arpu"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="activeArppu"
                                    label="arppu"
                                    width="100"
                                    align="center">
                                </el-table-column>
                            </el-table>
                            <!--表格end-->
                        </el-tab-pane>
                    </el-tabs>
                </el-tab-pane>
            </el-tabs>
        </el-tab-pane>

        <el-tab-pane name="44" label="塞尔之光Android">
            <el-tabs type="border-card">
                <el-tab-pane label="游戏数据">
                    <el-tabs type="border-card">
                        <el-tab-pane >
                        <span slot="label" ><i class="el-icon-view"></i> 图表</span>
                            <v-chart :force-fit="true"  :height="400" :data="view.srzgand">
                                <v-tooltip />
                                <v-axis />
                                <v-legend style="margin-right:40px"/>
                                <v-line position="month*temperature" color="city" />
                                <v-point position="month*temperature" color="city" :size="4" :v-style="style" />
                            </v-chart>
                        </el-tab-pane>
                        <el-tab-pane >
                        <span slot="label"><i class="el-icon-date"></i> 表格</span>
                            <!--表格start-->
                            <el-table
                                :data="list.srzgand"
                                border
                                style="width: 100% height:100%">
                                <el-table-column
                                    fixed
                                    prop="countDate"
                                    label="日期"
                                    width="100"
                                    align="center"
                                >
                                </el-table-column>
                                <el-table-column
                                    prop="addRegNum"
                                    label="新增"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="activeNum"
                                    label="活跃"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="payNum"
                                    label="付费"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                 <el-table-column
                                    prop="payAmountTotal"
                                    label="充值金额"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="addPayNum"
                                    label="新增付费数"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="addPayAmountTotal"
                                    label="新增充值"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="addPayRate"
                                    label="新增付费率"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="activeArpu"
                                    label="arpu"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="activeArppu"
                                    label="arppu"
                                    width="100"
                                    align="center">
                                </el-table-column>
                            </el-table>
                            <!--表格end-->
                        </el-tab-pane>
                    </el-tabs>
                </el-tab-pane>
            </el-tabs>
        </el-tab-pane>




























         <el-tab-pane name="3" label="紫禁繁花IOS">
            <el-tabs type="border-card">
                <el-tab-pane label="游戏数据">
                    <el-tabs type="border-card">
                        <el-tab-pane >
                        <span slot="label" ><i class="el-icon-view"></i> 图表</span>
                            <v-chart :force-fit="true"  :height="400" :data="view.zjfhios">
                                <v-tooltip />
                                <v-axis />
                                <v-legend style="margin-right:40px"/>
                                <v-line position="month*temperature" color="city" />
                                <v-point position="month*temperature" color="city" :size="4" :v-style="style" />
                            </v-chart>
                        </el-tab-pane>
                        <el-tab-pane >
                        <span slot="label"><i class="el-icon-date"></i> 表格</span>
                            <!--表格start-->
                            <el-table
                                :data="list.zjfhios"
                                border
                                style="width: 100% height:100%">
                                <el-table-column
                                    fixed
                                    prop="countDate"
                                    label="日期"
                                    width="100"
                                    align="center"
                                >
                                </el-table-column>
                                <el-table-column
                                    prop="addRegNum"
                                    label="新增"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="activeNum"
                                    label="活跃"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="payNum"
                                    label="付费"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                 <el-table-column
                                    prop="payAmountTotal"
                                    label="充值金额"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="addPayNum"
                                    label="新增付费数"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="addPayAmountTotal"
                                    label="新增充值"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="addPayRate"
                                    label="新增付费率"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="activeArpu"
                                    label="arpu"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="activeArppu"
                                    label="arppu"
                                    width="100"
                                    align="center">
                                </el-table-column>
                            </el-table>
                            <!--表格end-->
                        </el-tab-pane>
                    </el-tabs>
                </el-tab-pane>
            </el-tabs>
        </el-tab-pane>

        <el-tab-pane name="33" label="紫禁繁花Android">
            <el-tabs type="border-card">
                <el-tab-pane label="游戏数据">
                    <el-tabs type="border-card">
                        <el-tab-pane >
                        <span slot="label" ><i class="el-icon-view"></i> 图表</span>
                            <v-chart :force-fit="true"  :height="400" :data="view.zjfhand">
                                <v-tooltip />
                                <v-axis />
                                <v-legend style="margin-right:40px"/>
                                <v-line position="month*temperature" color="city" />
                                <v-point position="month*temperature" color="city" :size="4" :v-style="style" />
                            </v-chart>
                        </el-tab-pane>
                        <el-tab-pane >
                        <span slot="label"><i class="el-icon-date"></i> 表格</span>
                            <!--表格start-->
                            <el-table
                                :data="list.zjfhand"
                                border
                                style="width: 100% height:100%">
                                <el-table-column
                                    fixed
                                    prop="countDate"
                                    label="日期"
                                    width="100"
                                    align="center"
                                >
                                </el-table-column>
                                <el-table-column
                                    prop="addRegNum"
                                    label="新增"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="activeNum"
                                    label="活跃"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="payNum"
                                    label="付费"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                 <el-table-column
                                    prop="payAmountTotal"
                                    label="充值金额"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="addPayNum"
                                    label="新增付费数"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="addPayAmountTotal"
                                    label="新增充值"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="addPayRate"
                                    label="新增付费率"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="activeArpu"
                                    label="arpu"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="activeArppu"
                                    label="arppu"
                                    width="100"
                                    align="center">
                                </el-table-column>
                            </el-table>
                            <!--表格end-->
                        </el-tab-pane>
                    </el-tabs>
                </el-tab-pane>
            </el-tabs>
        </el-tab-pane>




        <el-tab-pane name="2" label="恋世界Android">
            <el-tabs type="border-card">
                <el-tab-pane label="游戏数据">
                    <el-tabs type="border-card">
                        <el-tab-pane >
                        <span slot="label" ><i class="el-icon-view"></i> 图表</span>
                            <v-chart :force-fit="true"  :height="400" :data="view.lsj">
                                <v-tooltip />
                                <v-axis />
                                <v-legend style="margin-right:40px"/>
                                <v-line position="month*temperature" color="city" />
                                <v-point position="month*temperature" color="city" :size="4" :v-style="style" />
                            </v-chart>
                        </el-tab-pane>
                        <el-tab-pane >
                        <span slot="label"><i class="el-icon-date"></i> 表格</span>
                            <!--表格start-->
                            <el-table
                                :data="list.lsj"
                                border
                                style="width: 100% height:100%">
                                <el-table-column
                                    fixed
                                    prop="countDate"
                                    label="日期"
                                    width="100"
                                    align="center"
                                >
                                </el-table-column>
                                <el-table-column
                                    prop="addRegNum"
                                    label="新增"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <!--el-table-column
                                    prop="activeNum"
                                    label="活跃"
                                    width="100"
                                    align="center">
                                </el-table-column-->
                                <el-table-column
                                    prop="payNum"
                                    label="付费"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                 <el-table-column
                                    prop="payAmountTotal"
                                    label="充值金额"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="addPayNum"
                                    label="新增付费数"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="addPayAmountTotal"
                                    label="新增充值"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="addPayRate"
                                    label="新增付费率"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="activeArpu"
                                    label="arpu"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="activeArppu"
                                    label="arppu"
                                    width="100"
                                    align="center">
                                </el-table-column>
                            </el-table>
                            <!--表格end-->
                        </el-tab-pane>
                    </el-tabs>
                </el-tab-pane>
            </el-tabs>
        </el-tab-pane>
        <el-tab-pane name="14" label="决胜足球Android">
            <el-tabs type="border-card">
                <el-tab-pane label="游戏数据">
                    <el-tabs type="border-card">
                        <el-tab-pane >
                        <span slot="label" ><i class="el-icon-view"></i> 图表</span>
                            <v-chart :force-fit="true"  :height="400" :data="view.jszq">
                                <v-tooltip />
                                <v-axis />
                                <v-legend style="margin-right:40px"/>
                                <v-line position="month*temperature" color="city" />
                                <v-point position="month*temperature" color="city" :size="4" :v-style="style" />
                            </v-chart>
                        </el-tab-pane>
                        <el-tab-pane >
                        <span slot="label"><i class="el-icon-date"></i> 表格</span>
                            <!--表格start-->
                            <el-table
                                :data="list.jszq"
                                border
                                style="width: 100% height:100%">
                                <el-table-column
                                    fixed
                                    prop="createDate"
                                    label="日期"
                                    width="100"
                                    align="center"
                                >
                                </el-table-column>
                                <el-table-column
                                    prop="disNewUsers"
                                    label="去重新增"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="newUsers"
                                    label="新增"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="activeUsers"
                                    label="活跃"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="rechargeUsers"
                                    label="付费"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                 <el-table-column
                                    prop="rechargePrice"
                                    label="充值金额"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="newRechargeUsers"
                                    label="新增付费数"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="newRechargePrice"
                                    label="新增充值"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="payRate"
                                    label="活跃付费率"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="arpu"
                                    label="arpu"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="arppu"
                                    label="arppu"
                                    width="100"
                                    align="center">
                                </el-table-column>
                            </el-table>
                            <!--表格end-->
                        </el-tab-pane>
                    </el-tabs>
                </el-tab-pane>
               
            </el-tabs>
        </el-tab-pane>

         <el-tab-pane name="10" label=" 超燃冒险团Android">
            <el-tabs type="border-card">
                <el-tab-pane label="游戏数据">
                    <el-tabs type="border-card">
                        <el-tab-pane >
                        <span slot="label" ><i class="el-icon-view"></i> 图表</span>
                            <v-chart :force-fit="true"  :height="400" :data="view.crmxt">
                                <v-tooltip />
                                <v-axis />
                                <v-legend style="margin-right:40px"/>
                                <v-line position="month*temperature" color="city" />
                                <v-point position="month*temperature" color="city" :size="4" :v-style="style" />
                            </v-chart>
                        </el-tab-pane>
                        <el-tab-pane >
                        <span slot="label"><i class="el-icon-date"></i> 表格</span>
                            <!--表格start-->
                            <el-table
                                :data="list.crmxt"
                                border
                                style="width: 100% height:100%">
                                <el-table-column
                                    fixed
                                    prop="createDate"
                                    label="日期"
                                    width="100"
                                    align="center"
                                >
                                </el-table-column>
                                <el-table-column
                                    prop="disNewUsers"
                                    label="去重新增"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="newUsers"
                                    label="新增"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="activeUsers"
                                    label="活跃"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="rechargeUsers"
                                    label="付费"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                 <el-table-column
                                    prop="rechargePrice"
                                    label="充值金额"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="newRechargeUsers"
                                    label="新增付费数"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="newRechargePrice"
                                    label="新增充值"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="payRate"
                                    label="活跃付费率"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="arpu"
                                    label="arpu"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="arppu"
                                    label="arppu"
                                    width="100"
                                    align="center">
                                </el-table-column>
                            </el-table>
                            <!--表格end-->
                        </el-tab-pane>
                    </el-tabs>
                </el-tab-pane>
               
            </el-tabs>
        </el-tab-pane>





    </el-tabs>
</template>
<script>
const DataSet = require('@antv/data-set');

export default {
    data() {
        return {
            style: { stroke: 'red', lineWidth: 1 },
            gameId:"4",
            deviceType:"1",
            list:{
                jszq:[{"date":"2018-01-01","newUsers":100,"activeUsers":1000}],//决胜足球
                lsj:[{"date":"2018-01-01","newUsers":100,"activeUsers":1000}],//恋世界  2 
                zjfhios:[{"date":"2018-01-01","newUsers":100,"activeUsers":1000}],// 紫禁繁花IOS 3
                zjfhand:[{"date":"2018-01-01","newUsers":100,"activeUsers":1000}],// 紫禁繁花AND 33
                srzgios:[{"date":"2018-01-01","newUsers":100,"activeUsers":1000}],// 塞尔之光IOS 4
                srzgand:[{"date":"2018-01-01","newUsers":100,"activeUsers":1000}],// 塞尔之光AND 44
                gtmzios:[{"date":"2018-01-01","newUsers":100,"activeUsers":1000}],// 宫廷秘传IOS 5
                gtmzand:[{"date":"2018-01-01","newUsers":100,"activeUsers":1000}],// 宫廷秘传AND 55
                crmxt:[],// 超燃冒险团
            },
            view:{
                jszq:[],
                lsj:[],
                zjfhios:[],// 紫禁繁花IOS 3
                zjfhand:[],// 紫禁繁花AND 33
                srzgios:[],// 塞尔之光IOS 4
                srzgand:[],// 塞尔之光AND 44
                gtmzios:[],// 宫廷秘传IOS 5
                gtmzand:[],// 宫廷秘传AND 55
                crmxt:[],// 超燃冒险团
            }
        };
    },
    mounted(){
        this.handleClick();
    },
    methods:{
        handleClick:function(){
            if(this.gameId == 14){
                this.jszqList();
            }else if(this.gameId == 2){
                this.deviceType = "1";
                this.lsjList();
            }else if(this.gameId == 3){
                this.deviceType = "0";
                this.zjfhiosList();
            }else if(this.gameId == 33){
                this.deviceType = "1";
                this.zjfhandList();cd
            }else if(this.gameId == 4){
                this.deviceType = "0";
                this.srzgiosList();
            }else if(this.gameId == 44){
                this.deviceType = "1";
                this.srzgandList();
            }else if(this.gameId == 5){
                this.deviceType = "0";
                this.gtmziosList();
            }else if(this.gameId == 55){
                this.deviceType = "1";
                this.gtmzandList();
            }else if(this.gameId == 10){
                this.crmxtList();
            }

        },

        //超燃冒险团图表数据
        crmxtView:function () {
            const sourceData = [
            ];
            this.list.crmxt.forEach(
                function (e){
                    e.createDate = e.createDate.substring(0,10);
                    sourceData.push({month:e.createDate.substring(5,10), 新增: e.newUsers, 活跃: e.activeUsers,充值人数:e.orders,付费:e.rechargePrice});
                }
            );
            const dv = new DataSet.View().source(sourceData);
            dv.transform({
                type: 'fold',
                fields: ['新增', '活跃','充值人数','付费'],
                key: 'city',
                value: 'temperature',
            });
            this.view.crmxt = dv.rows;
        },
        //超燃冒险团列表数据
        crmxtList:function(){
            this.tajax.post(
                "/api/csd/queryCsds",
                this.$qs.stringify({'key':'05b28d17a7b6e7024b6e5d8cc43a8bf7',"gameId":this.gameId}),
            ) .then((res)=>{
                this.list.crmxt = res.data;
                this.crmxtView();
            }).catch(err=>{
                alert(22);
            });
        },


        //决胜足球图表数据
        jszqView:function () {
            const sourceData = [
            ];
            this.list.jszq.forEach(
                function (e){
                    e.createDate = e.createDate.substring(0,10);
                    sourceData.push({month:e.createDate.substring(5,10), 新增: e.newUsers, 活跃: e.activeUsers,充值人数:e.orders,付费:e.rechargePrice});
                }
            );
            const dv = new DataSet.View().source(sourceData);
            dv.transform({
                type: 'fold',
                fields: ['新增', '活跃','充值人数','付费'],
                key: 'city',
                value: 'temperature',
            });
            this.view.jszq = dv.rows;
        },
        //决胜足球列表数据
        jszqList:function(){
            this.tajax.post(
                "/api/csd/queryCsds",
                this.$qs.stringify({'key':'05b28d17a7b6e7024b6e5d8cc43a8bf7',"gameId":this.gameId}),
            ) .then((res)=>{
                this.list.jszq = res.data;
                this.jszqView();
            }).catch(err=>{
                alert(22);
            });
        },

        //恋世界图表数据
        lsjView:function () {
            const sourceData = [
            ];
            this.list.lsj.forEach(
                function (e){
                    sourceData.push({month:e.countDate.substring(5,10), 新增: parseInt(e.addRegNum), 活跃: parseInt(e.activeNum),充值人数:parseInt(e.payNum),付费:parseInt(e.payAmountTotal)});
                }
            );
            const dv = new DataSet.View().source(sourceData);
            dv.transform({
            type: 'fold',
            fields: ['新增', '活跃','充值人数','付费'],
            key: 'city',
            value: 'temperature',
            });
            this.view.lsj = dv.rows;
        },
        //恋世界列表数据
        lsjList:function(){
            this.tajax.post(
                "/service/report/index",
                this.$qs.stringify({"deviceType":1,'password':123456,"gameType":2,"overseasType":0,"endDate":this.nowDate()}),
            ) .then((res)=>{
                this.list.lsj = res.data.data;
                this.lsjView();
            }).catch(err=>{
                alert(22);
            });
        },

         //紫禁繁花IOS图表数据
        zjfhiosView:function () {
            const sourceData = [
            ];
            this.list.zjfhios.forEach(
                function (e){
                    sourceData.push({month:e.countDate.substring(5,10), 新增: parseInt(e.addRegNum), 活跃: parseInt(e.activeNum),充值人数:parseInt(e.payNum),付费:parseInt(e.payAmountTotal)});
                }
            );
            const dv = new DataSet.View().source(sourceData);
            dv.transform({
            type: 'fold',
            fields: ['新增', '活跃','充值人数','付费'],
            key: 'city',
            value: 'temperature',
            });
            this.view.zjfhios = dv.rows;
        },
         //紫禁繁花IOS列表数据
        zjfhiosList:function(){
            this.tajax.post(
                "/service/report/index",
                this.$qs.stringify({"deviceType":this.deviceType,'password':123456,"gameType":3,"overseasType":1,"endDate":this.nowDate()}),
            ) .then((res)=>{
                this.list.zjfhios = res.data.data;
                this.zjfhiosView();
            }).catch(err=>{
                alert(22);
            });
        },

        //紫禁繁花android图表数据
        zjfhandView:function () {
            const sourceData = [
            ];
            this.list.zjfhand.forEach(
                function (e){
                    sourceData.push({month:e.countDate.substring(5,10), 新增: parseInt(e.addRegNum), 活跃: parseInt(e.activeNum),充值人数:parseInt(e.payNum),付费:parseInt(e.payAmountTotal)});
                }
            );
            const dv = new DataSet.View().source(sourceData);
            dv.transform({
            type: 'fold',
            fields: ['新增', '活跃','充值人数','付费'],
            key: 'city',
            value: 'temperature',
            });
            this.view.zjfhand = dv.rows;
        },
         //紫禁繁花android列表数据
        zjfhandList:function(){
            this.tajax.post(
                "/service/report/index",
                this.$qs.stringify({"deviceType":this.deviceType,'password':123456,"gameType":3,"overseasType":1,"endDate":this.nowDate()}),
            ) .then((res)=>{
                this.list.zjfhand = res.data.data;
                this.zjfhandView();
            }).catch(err=>{
                alert(22);
            });
        },


         //塞尔之光IOS图表数据
        srzgiosView:function () {
            const sourceData = [
            ];
            this.list.srzgios.forEach(
                function (e){
                    sourceData.push({month:e.countDate.substring(5,10), 新增: parseInt(e.addRegNum), 活跃: parseInt(e.activeNum),充值人数:parseInt(e.payNum),付费:parseInt(e.payAmountTotal)});
                }
            );
            const dv = new DataSet.View().source(sourceData);
            dv.transform({
            type: 'fold',
            fields: ['新增', '活跃','充值人数','付费'],
            key: 'city',
            value: 'temperature',
            });
            this.view.srzgios = dv.rows;
        },
         //塞尔之光IOS列表数据
        srzgiosList:function(){
            this.tajax.post(
                "/service/report/index",
                this.$qs.stringify({"deviceType":this.deviceType,'password':123456,"gameType":4,"overseasType":0,"endDate":this.nowDate()}),
            ) .then((res)=>{
                this.list.srzgios = res.data.data;
                this.srzgiosView();
            }).catch(err=>{
                alert(22);
            });
        },

        //塞尔之光android图表数据
        srzgandView:function () {
            const sourceData = [
            ];
            this.list.srzgand.forEach(
                function (e){
                    sourceData.push({month:e.countDate.substring(5,10), 新增: parseInt(e.addRegNum), 活跃: parseInt(e.activeNum),充值人数:parseInt(e.payNum),付费:parseInt(e.payAmountTotal)});
                }
            );
            const dv = new DataSet.View().source(sourceData);
            dv.transform({
            type: 'fold',
            fields: ['新增', '活跃','充值人数','付费'],
            key: 'city',
            value: 'temperature',
            });
            this.view.srzgand = dv.rows;
        },
         //塞尔之光android列表数据
        srzgandList:function(){
            this.tajax.post(
                "/service/report/index",
                this.$qs.stringify({"deviceType":this.deviceType,'password':123456,"gameType":4,"overseasType":0,"endDate":this.nowDate()}),
            ) .then((res)=>{
                this.list.srzgand = res.data.data;
                this.srzgandView();
            }).catch(err=>{
                alert(22);
            });
        },





         //宫廷秘传IOS图表数据
        gtmziosView:function () {
            const sourceData = [
            ];
            this.list.gtmzios.forEach(
                function (e){
                    sourceData.push({month:e.countDate.substring(5,10), 新增: parseInt(e.addRegNum), 活跃: parseInt(e.activeNum),充值人数:parseInt(e.payNum),付费:parseInt(e.payAmountTotal)});
                }
            );
            const dv = new DataSet.View().source(sourceData);
            dv.transform({
            type: 'fold',
            fields: ['新增', '活跃','充值人数','付费'],
            key: 'city',
            value: 'temperature',
            });
            this.view.gtmzios = dv.rows;
        },
         //宫廷秘传IOS列表数据
        gtmziosList:function(){
            this.tajax.post(
                "/service/report/index",
                this.$qs.stringify({"deviceType":this.deviceType,'password':123456,"gameType":5,"overseasType":0,"endDate":this.nowDate()}),
            ) .then((res)=>{
                this.list.gtmzios = res.data.data;
                this.gtmziosView();
            }).catch(err=>{
                alert(22);
            });
        },

        //宫廷秘传android图表数据
        gtmzandView:function () {
            const sourceData = [
            ];
            this.list.gtmzand.forEach(
                function (e){
                    sourceData.push({month:e.countDate.substring(5,10), 新增: parseInt(e.addRegNum), 活跃: parseInt(e.activeNum),充值人数:parseInt(e.payNum),付费:parseInt(e.payAmountTotal)});
                }
            );
            const dv = new DataSet.View().source(sourceData);
            dv.transform({
            type: 'fold',
            fields: ['新增', '活跃','充值人数','付费'],
            key: 'city',
            value: 'temperature',
            });
            this.view.gtmzand = dv.rows;
        },
         //宫廷秘传android列表数据
        gtmzandList:function(){
            this.tajax.post(
                "/service/report/index",
                this.$qs.stringify({"deviceType":this.deviceType,'password':123456,"gameType":5,"overseasType":0,"endDate":this.nowDate()}),
            ) .then((res)=>{
                this.list.gtmzand = res.data.data;
                this.gtmzandView();
            }).catch(err=>{
                alert(22);
            });
        },
















        nowDate:function() {
            var date = new Date();
            var seperator1 = "-";
            var year = date.getFullYear();
            var month = date.getMonth() + 1;
            var strDate = date.getDate();
            if (month >= 1 && month <= 9) {
            month = "0" + month;
            }
            if (strDate >= 0 && strDate <= 9) {
            strDate = "0" + strDate;
            }
            var currentdate = year + seperator1 + month + seperator1 + strDate;
            return currentdate;
        },
    }
};
</script>
<style>
.el-tabs__nav-scroll{
   overflow :auto
}
</style>



// WEBPACK FOOTER //
// src/admin/page.vue